import { render, staticRenderFns } from "./PointHistory.vue?vue&type=template&id=57a9bae0"
import script from "./PointHistory.vue?vue&type=script&lang=js"
export * from "./PointHistory.vue?vue&type=script&lang=js"
import style0 from "./PointHistory.vue?vue&type=style&index=0&id=57a9bae0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports